"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageToSepia = void 0;

var _RgbaImageBuffer = _interopRequireDefault(require("../RgbaImageBuffer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Returns the given pixels converted to sepia
 *
 * @param {RgbaImageBuffer} imgBuffer Image Buffer base to create the sepia
 * image from
 * @returns {RgbaImageBuffer} Image buffer with sepia effect
 */


var imageToSepia = function imageToSepia(imgBuffer) {
  var result = imgBuffer.copy();

  for (var i = 0; i < result.pixels.length; i += _RgbaImageBuffer.default.NUM_CHANNELS) {
    var redValue = imgBuffer.pixels[i];
    var greenValue = imgBuffer.pixels[i + 1];
    var blueValue = imgBuffer.pixels[i + 2];
    result.pixels[i] = Math.min(redValue * 0.393 + greenValue * 0.769 + blueValue * 0.189, 255);
    result.pixels[i + 1] = Math.min(redValue * 0.349 + greenValue * 0.686 + blueValue * 0.168, 255);
    result.pixels[i + 2] = Math.min(redValue * 0.272 + greenValue * 0.534 + blueValue * 0.131, 255);
  }

  return result;
};

exports.imageToSepia = imageToSepia;